// MUI
import { Box, Typography } from '@mui/material';

const RegisterHeader = () => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mb: 3,
        width: '100%',
      }}
    >
      <Box
        component="img"
        src="/logo.png"
        alt="VCAT Logo"
        sx={{
          display: 'block',
          mx: 'auto',
          width: { xs: 120, sm: 150 },
        }}
      />

      <Typography
        variant="h5"
        sx={{
          mt: 2,
          color: '#FFF',
          fontWeight: 'bold'
        }}
      >
        Create Account
      </Typography>
    </Box>
  );
};

export { RegisterHeader };